import { app } from '../content.js'
import Slideshow from '../components/Slideshow.jsx'

export default function MobileApp() {
  return (
    <section className="section" id="app">
      <div className="container">
        <div className="section-head">
          <span className="eyebrow">{app.eyebrow}</span>
          <h2>{app.title}</h2>
          <p>{app.text}</p>
        </div>
        <Slideshow slides={app.screens} phone />
      </div>
    </section>
  )
}
